/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAudioShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="m7.764 17 1.849-4.87h1.011L12.487 17h-1.166L11 16.002H9.204L8.882 17zm1.721-1.883h1.227l-.617-1.916zm3.279-.415v-2.573h1.045v2.553c0 .531.079.916.235 1.152.156.233.404.349.744.349.344 0 .591-.116.743-.349.157-.236.235-.62.235-1.152v-2.553h1.045v2.573c0 .822-.165 1.427-.496 1.816-.326.384-.835.576-1.527.576-.693 0-1.204-.192-1.535-.576-.326-.389-.489-.994-.489-1.816zM17.686 17v-4.87h1.635c.795 0 1.396.205 1.802.616.407.41.61 1.018.61 1.822 0 .795-.203 1.4-.61 1.816-.402.41-1.003.616-1.802.616zm1.622-4.02h-.577v3.17h.577c.45 0 .786-.128 1.005-.383.223-.259.335-.659.335-1.199s-.11-.94-.329-1.2c-.219-.258-.556-.388-1.011-.388zM2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileAudioShortcut as FileAudioShortcut };
